export default class GetSubsedesAsignaciones {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllSubsedes()
      return result
    } catch (error) {
      console.error('Error al obtener las subsedes y sus asignaciones:', error)
      throw error
    }
  }
}
